import React, { Component } from 'react';
import { Table } from 'react-bootstrap'
import Api from './../../../Global/Modules/Api'

const FETCH_URL = "api/references/"

class WerkervaringOverzichtSingle extends Component {
    constructor() {
        super()
        this.handleEdit = this.handleEdit.bind(this)
        this.handleDelete = this.handleDelete.bind(this)
        this.getReferences = this.getReferences.bind(this)
        this.state = {
            references: []
        }
    }

    // To pass parameters to event handlers while using property initializer syntax, we need to use currying.
    handleEdit = id => event => {
        event.preventDefault()
        Api.print(`Handle edit of: ${id}`)
        this.props.handle(id)
    }

    getReferences() {
        Api.GetApi(FETCH_URL+"?PageSize=101").then(data => {
            if (data !== undefined) {
                let references = data.references.map((ref, index) => {
                    return (<tr key={ref + index}>
                        <td>{ref.abbreviation}</td>
                        <td>{ref.firstName}</td>
                        <td>{ref.middleName}</td>
                        <td>{ref.lastName}</td>
                        <td>{ref.company}</td>
                        <td>{ref.function}</td>
                        <td>{ref.phone}</td>
                        <td>{ref.email} <a href="" onClick={this.handleEdit(ref.id)}>(wijzigen)</a></td>
                        <td><a href="" onClick={this.handleDelete(ref.id)}>X</a></td>
                    </tr>)
                })

                this.setState({ references: references })
            }
        })
    }

    // To pass parameters to event handlers while using property initializer syntax, we need to use currying.   
    handleDelete = id => event => {
        event.preventDefault()
        Api.DeleteApi(FETCH_URL + id).then(response => {
            Api.print(`Response delete ${id}`)
            Api.print(response)
            this.getReferences()
        })
    }

    componentDidMount() {
        this.getReferences()
    }

    render() {
        return (
            <div>
                <h5><strong>Bestaande Referenties</strong></h5>
                <Table responsive striped bordered hover>
                    <thead>
                        <tr>
                            <th>Afkorting</th>
                            <th>Voornaam</th>
                            <th>Tussenvoegsel</th>
                            <th>Achternaam</th>
                            <th>Bedrijf</th>
                            <th>Functie</th>
                            <th>Telefoon</th>
                            <th>E-mail</th>
                            <th>&nbsp;</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.references}
                    </tbody>
                </Table>
            </div>
        );
    }
}

export default WerkervaringOverzichtSingle;


// WEBPACK FOOTER //
// ./src/components/Member/Modules/Werkervaring/WerkervaringReferentieOverzicht.js